module.exports = __webpack_public_path__ + "static/media/banner_avaliacoes.2598c639.png";